var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountGreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account icon-green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 29,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.2%",
    y: "-1.7%",
    width: "108.3%",
    height: "106.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.22745098   0 0 0 0 0.51372549   0 0 0 0 0.235294118  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auth,-Account-+-Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Current-model---managed-by-parent",
    transform: "translate(-342.000000, -222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(154.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "welcome-banner",
    transform: "translate(172.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-icon-green",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#D4E8D9",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "form-icon",
    transform: "translate(12.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-2",
    transform: "translate(12.747712, 16.122366) rotate(-6.000000) translate(-12.747712, -16.122366) translate(1.747712, 1.622366)",
    fill: "#3A833C",
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 21.2571429,
    height: 28.1982691,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "document-1",
    transform: "translate(6.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#C5E8C9",
    x: 3.16666667,
    y: 5.42121212,
    width: 6.11111111,
    height: 3.39393939,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    stroke: "#C5E8C9",
    x: 12.0555556,
    y: 5.42121212,
    width: 8.77777778,
    height: 3.39393939,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C5E8C9",
    x: 2.66666667,
    y: 14.0606061,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0909090909,18.3666667 L15.9090909,18.3666667 L15.9090909,18.3666667 L0.0909090909,18.3666667 L0.0909090909,18.3666667 Z",
    id: "Rectangle",
    fill: "#DFE1E7",
    transform: "translate(8.000000, 18.366667) rotate(90.000000) translate(-8.000000, -18.366667) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C5E8C9",
    x: 2.66666667,
    y: 17.1363636,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    fill: "#C5E8C9",
    x: 2.66666667,
    y: 2.63636364,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C5E8C9",
    x: 2.66666667,
    y: 20.2121212,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C5E8C9",
    x: 2.66666667,
    y: 23.2878788,
    width: 18.6666667,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    stroke: "#C5E8C9",
    x: 3.16666667,
    y: 11.0454545,
    width: 17.6666667,
    height: 14.8181818,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "pen",
    transform: "translate(24.233163, 24.225261) rotate(-138.000000) translate(-24.233163, -24.225261) translate(21.233163, 11.225261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.12299761,1.27312854 L2.79757496,1.44385291 C3.0500348,1.44385291 3.28082672,1.5874375 3.39373018,1.81474417 L4.40488645,4.25011516 C4.56951017,4.58154934 4.5091421,4.73208552 4.17989466,4.89780262 C4.08734448,4.94438505 3.98529129,4.96863654 3.88181705,4.96863654 L0.786435239,4.96863654 C0.41832541,4.96863654 0.315407313,4.8246849 0.315407313,4.45413021 C0.315407313,4.34996873 0.297859683,4.15622044 0.344134771,4.06305558 L1.47668647,2.04556915 C1.58958994,1.81826249 1.87053777,1.27312854 2.12299761,1.27312854 Z",
    id: "Rectangle-7",
    fill: "#F7FCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.29665427,3.86353633 C4.90027915,4.02699147 4.56215167,4.37534652 4.62093874,6.93331809 L4.62093874,23.4006667 C4.62093874,24.4500511 3.62956926,25.3007453 2.40665303,25.3007453 C1.18373679,25.3007453 0.192367314,24.4500511 0.192367314,23.4006667 L0.192367314,6.93331809 C0.325959105,4.30817626 -0.306970604,3.70008118 2.29665427,3.86353633 Z",
    id: "Rectangle-4",
    fill: "#61C16C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#3A833C",
    points: "2.49525789 0.283177334 3.51382932 2.04556915 1.47668647 2.04556915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09578593,11.9743985 L4.51843666,11.9743985 C4.89089138,11.9743985 5.19282558,12.1889656 5.19282558,12.4536474 L5.19282558,20.3071085 C5.19282558,20.5717905 4.89089138,20.7863575 4.51843666,20.7863575 L4.09578593,20.7863575 C3.72333122,20.7863575 3.42139701,20.5717905 3.42139701,20.3071085 L3.42139701,12.4536474 C3.42139701,12.1889656 3.72333122,11.9743985 4.09578593,11.9743985 Z",
    id: "Rectangle-5",
    fill: "#3A833C"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountGreenIcon);
export default __webpack_public_path__ + "static/media/account-green-icon.fb6fa6a71fea2e9b85404ff7d4c26eaf.svg";
export { ForwardRef as ReactComponent };